import { DistributionBatchStatus, DistributionBatchType } from "../../config/constants/common";
import { AssetDistributionQueryParams, IAssetRecord, ICreateAssetDistribution,IDistributionBatchRecord } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

interface ExportParams {
  page?: number;
  page_size?: number;
  batch_number?: string;
  to_location_id?: string;
  from_location_id?: string;
  is_deleted?: boolean;
  distribution_batch_status?: DistributionBatchType;
  file_format: 'pdf' | 'csv';
}

const createBatchDistribution = async (data: ICreateAssetDistribution) => {
  return apiService.apiRequest<Partial<ICreateAssetDistribution>>(
    "post",
    `asset-distributions`,
    data
  );
};

const getBatchDistributions = async (queryParams?: {
  page?: number;
  page_size?: number;
  batch_number?: string;
  to_location_id?: string;
  from_location_id?:string
  is_deleted?: boolean;
  distribution_batch_status?:DistributionBatchType
},
defaultQuery?:{
  to_location_id?: string;
  from_location_id?:string
}) => {
  const query = buildQueryString({...queryParams,...defaultQuery});
  return apiService.apiRequest<IDistributionBatchRecord[]>("get", `asset-distributions${query}`);
};

const getReceivedBatchDistributions = async (queryParams?: {
  page?: number;
  page_size?: number;
  batch_number?: string;
  to_location_id?: string;
  is_deleted?: boolean;
  distribution_batch_status?:DistributionBatchType
}) => {

  const __query={
    ...queryParams,
    distribution_batch_status:DistributionBatchStatus.received
  }
  const query = buildQueryString(__query);
  return apiService.apiRequest<IDistributionBatchRecord[]>("get", `asset-distributions${query}`);
};

const getBatchDistribution = async (asset_distribution_batch_id: string) => {
  return apiService.apiRequest<IDistributionBatchRecord>("get", `asset-distributions/${asset_distribution_batch_id}`);
};

const getAssetFromDistribution = async (asset_distribution_batch_id: string,queryParams?:AssetDistributionQueryParams) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IAssetRecord[]>("get", `asset-distributions/${asset_distribution_batch_id}/assets${query}`);
};

const deleteBatchDistribution = async (asset_distribution_batch_id: string) => {
  return apiService.apiRequest<any>(
    "delete",
    `asset-distributions/${asset_distribution_batch_id}`
  );
};

const removeAssetFromDistribution = async (asset_distribution_batch_id: string,asset_id:string) => {
  return apiService.apiRequest<any>(
    "delete",
    `asset-distributions/${asset_distribution_batch_id}/assets/${asset_id}`
  );
};

const updateBatchDistribution = async (asset_distribution_batch_id: string,data:Partial<ICreateAssetDistribution>) => {
  return apiService.apiRequest<any>(
    "put",
    `asset-distributions/${asset_distribution_batch_id}`,data
  );
};

const restoreBatchDistribution = async (asset_distribution_batch_id: string) => {
  return apiService.apiRequest<any>(
    "put",
    `asset-distributions/${asset_distribution_batch_id}/restore`
  );
};

const accept = async (asset_distribution_batch_id: string,assets:string[]) => {
  return apiService.apiRequest<any>(
    "patch",
    `asset-distributions/accept/${asset_distribution_batch_id}`,
    {assets}
  );
};

const reject = async (asset_distribution_batch_id: string,assets:string[],reason:string) => {
  return apiService.apiRequest<any>(
    "patch",
    `asset-distributions/reject/${asset_distribution_batch_id}`,
     {assets, reason}
  );
};

const exportAssetDistributions = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `asset-distributions/export${query}`
  );
};

export const assetBatchDistributionApi = {
  createBatchDistribution,
  getBatchDistributions,
  getReceivedBatchDistributions,
  getBatchDistribution,
  deleteBatchDistribution,
  restoreBatchDistribution,
  updateBatchDistribution,
  getAssetFromDistribution,
  removeAssetFromDistribution,
  accept,
  reject,
  exportAssetDistributions, 
};